import moment from 'moment';
import { getSmsCampaignList } from '../services';
import { formatNumber } from '@/utilities/formatters';
export const fetchSmsCampaignList = (params) => {
    return getSmsCampaignList(params)
        .then(response => formatResponse(response.data))
        .catch(() => ({
        success: false,
        columns: [],
        data: [],
        totalCount: 0,
    }));
};
const formatResponse = (response) => {
    return {
        success: response.success,
        columns: [
            ...response.data.columns
                .map(column => ({
                key: column.key,
                label: column.name,
            }))
                .filter(column => column.key !== 'sent'),
            { key: 'actions', label: '' },
        ],
        data: response.data.data?.map(campaign => ({
            campaignId: campaign.id,
            status: campaign.status,
            name: campaign.name,
            message: campaign.message,
            sentDate: formatCampaignDate(campaign),
            sent: formatNumber(campaign.sent),
            audienceId: campaign.audienceFk,
            total: formatNumber(campaign.total),
            createDate: campaign.createDate,
        })) || [],
        totalCount: response.data.totalCount,
    };
};
const formatCampaignDate = (campaign) => campaign.status === 'disabled' ? '-' : moment(campaign.sentDate).format('DD/MM/YY - HH:mm');
